import React from "react";
import { Button } from "semantic-ui-react";
import SimpleInputComponent from "../forms/SimpleInputComponent";
import useCustomerReviewsFilters from "../../hooks/useCustomerReviewsFilters";
import useInteractions from "../../hooks/useInteractions";
import { DatesRangeInput } from "semantic-ui-calendar-react";
import {
  CustomerSessionsFilters,
  InteractionsFilters,
  ReviewsFilters,
} from "./CustomerReviewFilters";
import useCustomerView from "../../../../hooks/useCustomerView";
import CustomerReviewFiltersAction from "@common/redux/actions/CustomerReviewFiltersAction";
import CustomerAction from "@common/redux/actions/CustomerAction";

const CustomerReviewFiltersDesktop = () => {
  const { interactionDateRange } = useInteractions();
  const { id, dateRange, showFilters, onDatesChange, onInputChange } =
    useCustomerReviewsFilters();
  const {
    selectedCustomer,
    activeViewTab,
    getCustomerInteractions,
    getCustomerSessions,
    getCustomerReviews,
  } = useCustomerView();

  const fnRefresh = () =>
    activeViewTab === 2
      ? getCustomerSessions(selectedCustomer?.customer?.id)
      : activeViewTab === 3
        ? getCustomerReviews(selectedCustomer?.customer?.id)
        : getCustomerInteractions(selectedCustomer?.customer?.id);

  const clearFilters = () => {
    CustomerAction.reset();
    CustomerReviewFiltersAction.reset();
  };

  const currentFilters = (activeViewTab) => {
    switch (activeViewTab) {
      case 1:
        return InteractionsFilters;
      case 2:
        return CustomerSessionsFilters;
      case 3:
        return ReviewsFilters;
      default:
        return <></>;
    }
  };

  const CurrentFiltersComponent = currentFilters(activeViewTab);

  return (
    <div className={`flex-wrap gap-1 px-1`}>
      {showFilters && (
        <>
          <SimpleInputComponent
            name="id"
            label="ID Search:"
            className="w-10em"
            value={id}
            onChange={onInputChange}
          />
          <div>
            <b>Date range:</b>
            <DatesRangeInput
              name={activeViewTab === 1 ? "interactionDateRange" : "dateRange"}
              placeholder="From - To"
              dateFormat="YYYY-MM-DD"
              value={activeViewTab === 1 ? interactionDateRange : dateRange}
              iconPosition="left"
              onChange={onDatesChange}
              closable
              style={{ width: "10em" }}
            />
          </div>
          <CurrentFiltersComponent />
          <Button className="ml-1" positive onClick={fnRefresh}>
            Refresh
          </Button>
          <Button className="ml-1" onClick={clearFilters}>
            Clear
          </Button>
        </>
      )}
    </div>
  );
};

export default CustomerReviewFiltersDesktop;
